import React from 'react'

const SvgThoughtFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.976 4.02a3.953 3.953 0 013.953 3.953 3.953 3.953 0 011.949 7.393 3.954 3.954 0 01-6.7 2.34 4.942 4.942 0 01-7.685-1.828 3.459 3.459 0 01-.41-6.882v-.035a2.965 2.965 0 015.09-2.067 3.955 3.955 0 013.803-2.874zm-6.628 8.605a.988.988 0 101.398-1.398.988.988 0 00-1.398 1.398zm3.953 0a.988.988 0 101.398-1.398.988.988 0 00-1.398 1.398zm3.953 0a.988.988 0 101.398-1.398.988.988 0 00-1.398 1.398z'
    />
  </svg>
)

export default SvgThoughtFilled
